module.exports = __webpack_public_path__ + "img/financial-times-screener.a972b4c1.png";